'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  align-items: center;\n  border-radius: ', ';\n  box-sizing: border-box;\n  color: ', ';\n  display: flex;\n  font-size: initial;\n  ', '\n  height: ', ';\n  overflow: hidden;\n  position: relative;\n  width: ', ';\n'], ['\n  align-items: center;\n  border-radius: ', ';\n  box-sizing: border-box;\n  color: ', ';\n  display: flex;\n  font-size: initial;\n  ', '\n  height: ', ';\n  overflow: hidden;\n  position: relative;\n  width: ', ';\n']);

var _colors = require('HubStyleTokens/colors');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _Constants = require('../../Constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ContentHolder = (0, _styledComponents2.default)('div').withConfig({
  displayName: 'AvatarContentHolder__ContentHolder'
})(_templateObject, function (props) {
  return _Constants.AVATAR_TYPES[props.type] === _Constants.AVATAR_TYPES.productId ? '3px' : '50%';
}, _colors.OLAF, function (props) {
  return props._isListReversed && 'border: 2px solid ' + _colors.OLAF + ';';
}, function (props) {
  return props.size && props.size !== _Constants.AVATAR_SIZES.responsive ? _Constants.AVATAR_SIZES[props.size] + 'px' : 'inherit';
}, function (props) {
  return props.size && props.size !== _Constants.AVATAR_SIZES.responsive ? _Constants.AVATAR_SIZES[props.size] + 'px' : '100%';
});

var AvatarContentHolder = function AvatarContentHolder(props) {
  var href = props.href,
      children = props.children,
      size = props.size,
      type = props.type,
      _isListReversed = props._isListReversed;

  var avatarWidth = size === _Constants.AVATAR_SIZES.responsive ? '100%' : '$[size}';
  var avatarHeight = size === _Constants.AVATAR_SIZES.responsive ? '' : '$[size}';

  if (href) {
    return _react2.default.createElement(
      _UIButton2.default,
      {
        style: {
          width: avatarWidth,
          height: avatarHeight
        },
        use: 'unstyled',
        href: href
      },
      _react2.default.createElement(
        ContentHolder,
        {
          type: type,
          _isListReversed: _isListReversed,
          size: size
        },
        children
      )
    );
  }

  return _react2.default.createElement(
    ContentHolder,
    { type: type, _isListReversed: _isListReversed, size: size },
    children
  );
};

AvatarContentHolder.propTypes = {
  children: _react.PropTypes.node.isRequired,
  href: _react.PropTypes.string,
  size: _react.PropTypes.oneOf(Object.keys(_Constants.AVATAR_SIZES)),
  type: _react.PropTypes.oneOf(Object.keys(_Constants.AVATAR_TYPES)),
  _isListReversed: _react.PropTypes.bool
};

exports.default = AvatarContentHolder;
module.exports = exports['default'];